import { expectEl } from "../util";
import { Scene } from "../gameData";
import { createSceneElement } from "./createSceneElement";

export function addSceneElements(scene: Scene) {
    const elementsEl = expectEl("#game .elements");
    elementsEl.innerHTML = "";

    if (!scene.elements) {
        return;
    }

    for (const sceneElement of Object.values(scene.elements)) {
        const el = createSceneElement(sceneElement);
        elementsEl.appendChild(el);
    }
}
